// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import { padding } from 'polished';

import Icon from 'app/components/commons/Icon';
import RewriteLink from 'app/components/routing/RewriteLink';
import Tab from 'app/components/sportsFilters/Tab';
import Tappable from 'app/components/commons/Tappable';

type Props = {
  active?: boolean,
  className?: string,
  children: any,
  disabled?: boolean,
  href?: string,
  onClick?: () => void,
  icon?: string,
  image?: string,
  spartan?: boolean
};

const ClickArea = styled(({ href, onClick, disabled, ...props }) => {
  if (disabled) {
    return <span {...props} />;
  }
  if (href) {
    return <RewriteLink to={href} {...props} />;
  }
  return <span {...props} />;
})(
  {
    position: 'relative',
    alignItems: 'center',
    color: 'inherit',
    display: 'flex',
    flexBasis: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: 80,
    overflow: 'hidden',
    ...padding(20, 10)
  },
  ({ href }) => ({
    cursor: href ? 'pointer' : 'disabled'
  })
);

const SportsIcon = styled(Icon)(({ active, theme }) => ({
  color: active ? theme.color.white : undefined,
  fontSize: 28,
  marginBottom: 4
}));

const Text = styled.div(({ theme }) => ({
  fontSize: 16,
  fontWeight: theme.fontWeight.demiBold,
  [theme.mediaQuery.desktopAndUp]: {
    marginTop: 1
  }
}));

class SportsFilterTab extends React.PureComponent<Props> {
  props: Props;

  static defaultProps = {
    active: false,
    className: undefined,
    disabled: false,
    href: undefined,
    icon: undefined,
    image: undefined,
    onClick: undefined,
    spartan: false
  };

  render() {
    const {
      active,
      children,
      className,
      disabled,
      href,
      icon,
      image,
      spartan,
      onClick
    } = this.props;

    return (
      <Tab active={active} disabled={disabled} className={className} spartan={spartan}>
        <Tappable component={ClickArea} href={href} disabled={disabled} onTap={onClick}>
          <SportsIcon active={active} type={icon} image={image} />
          <Text>{children}</Text>
        </Tappable>
      </Tab>
    );
  }
}

export default SportsFilterTab;
